import clsx from 'clsx';
import React__default from 'react';

const BreadCrumbItem = ({ children, current = false, ...aProps }) => {
    const attr = {};
    if (current) {
        attr['aria-current'] = 'page';
    }
    return (React__default.createElement("div", { className: 'c-breadcrumb__item', ...attr },
        React__default.createElement("a", { ...aProps }, children)));
};
const BreadCrumbs = ({ dark, children, className, ...navProps }) => (React__default.createElement("nav", { ...navProps, className: clsx(className, {
        'c-breadcrumb': true,
        'c-breadcrumb--theme-dark': dark
    }), "aria-label": 'breadcrumb' }, children));

export { BreadCrumbItem, BreadCrumbs };
//# sourceMappingURL=index.js.map
